import {createSlice, isAnyOf} from "@reduxjs/toolkit";
import {
    FETCH_STATUS_FAILED,
    FETCH_STATUS_IDLE,
    FETCH_STATUS_LOADING,
    FETCH_STATUS_SUCCEEDED
} from "../../utils/constants";
import {
    addEorInvoiceDetails,
    fetchPayrolls,
    resetPayrollsUpdateStatus,
    setEmployeePaid,
    updatePayroll
} from "./actions";
import {Payroll, PayrollsState} from "../interfaces";

const initialState: PayrollsState = {
    status: 'idle',
    updateStatus: 'idle',
    error: undefined,
    updateError: undefined,
    payrolls: [],
}

const updatePayrollList = (state: PayrollsState, updatedPayroll: Payroll) => {
    state.payrolls = state.payrolls.map((payroll) =>
        payroll._id === updatedPayroll._id ? updatedPayroll : payroll
    )
}
export const payrollsSlice = createSlice({
    name: 'payrolls',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchPayrolls.pending, (state, action) => {
                state.status = FETCH_STATUS_LOADING
            })
            .addCase(fetchPayrolls.fulfilled, (state, action) => {
                state.status = FETCH_STATUS_SUCCEEDED
                if (action.payload.error) {
                    state.error = action.payload.error
                    return;
                }
                state.payrolls = [...action.payload.payrolls]
            })
            .addCase(fetchPayrolls.rejected, (state, action) => {
                state.status = FETCH_STATUS_FAILED
                state.error =  state.error = (action.payload as any)?.message || action.error.message;
            })

        builder
            .addCase(resetPayrollsUpdateStatus, (state) => {
                state.updateStatus = FETCH_STATUS_IDLE;
                state.updateError = undefined;
            })

        builder
            .addMatcher(
                isAnyOf(
                    updatePayroll.pending,
                    addEorInvoiceDetails.pending,
                    setEmployeePaid.pending
                ),
                (state, action) => {
                    state.updateStatus = FETCH_STATUS_LOADING;
                }
            )
            .addMatcher(
                isAnyOf(
                    updatePayroll.fulfilled,
                    addEorInvoiceDetails.fulfilled,
                    setEmployeePaid.fulfilled
                ), (state, action) => {
                    state.updateStatus = FETCH_STATUS_SUCCEEDED
                    updatePayrollList(state, action.payload.payroll);
                }
            )
            .addMatcher(
                isAnyOf(
                    updatePayroll.rejected,
                    addEorInvoiceDetails.rejected,
                    setEmployeePaid.rejected
                ), (state, action) => {
                    state.updateStatus = FETCH_STATUS_FAILED
                    state.updateError = (action.payload as any)?.error || action.error.message;
                }
            )
    }
})

export default payrollsSlice.reducer
